<template>
    <div class="supplier-view">
      
      <div class="supplier-info">
        <div class="info-row">
          <div class="info-item">
            <label>Name</label>
            <input type="text" v-model="contactData.name" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          <div class="info-item">
            <label>Email</label>
            <input type="email" v-model="contactData.email" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          <div class="info-item">
            <label>Phone</label>
            <input type="text" v-model="contactData.phone" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          
          
        </div>
        
        <div class="info-row">
    
          <div class="info-item">
            <label>Address</label>
            <input type="text" v-model="contactData.address" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          <div class="info-item">
            <label>Postal Code</label>
            <input type="text" v-model="contactData.postal"  :disabled="!editMode" :class="{ 'enabled': editMode}" />
          </div>
         
          <div class="info-item">
            <label>ΑΦΜ</label>
            <input type="text" v-model="contactData.afm" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          
        </div>
        
        <div class="info-row">
          <div class="info-item">
            <label>Occupation</label>
            <input type="text" v-model="contactData.occupation" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          <div class="info-item">
            <label>Description</label>
            <input type="text" v-model="contactData.description" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
        
         
          
        </div>

        <div class="info-row " style="width:32.6%">
          
          <div class="info-item ">
            <label class="form-label">Client</label>
            <Select2 :options="allData.clients" v-model="contactData.clientId" :settings="select2Settings" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          <div class="info-item ">
            <label class="form-label">Supplier</label>
            <Select2 :options="allData.suppliers" v-model="contactData.supplierId" :settings="select2Settings" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          
        </div>
      </div>
      
      <div class="actions">
        <button @click="cancelEdit" class="cancel-btn" v-if="editMode">CANCEL</button>
        <button @click="editContact" v-if="!editMode && (canEditContact || canEditAllContacts || superUser)" class="edit-btn">EDIT</button>
        <button class="save-btn" v-if="editMode" @click="save">SAVE</button>
      </div><br><br>


      <div class="d-flex mt-sm-0 mt-3 justify-content-between">
        <h4 class="fw-bolder">Contact Notes</h4>
        <button type="button" class="ms-0 ms-sm-3 btn btn-dark" style="color:var(--secondary-color); font-weight:bold" 
        @click="openCreateNoteModal()" ><i class="icofont-plus me-2 fs-6"></i>New Note</button>
                                    
                                </div>


<table id="projectTable" class="table table-hover align-middle mb-0 mis_table" style="width:100%">
    <thead>
        <tr>
            
            <th style="width:10%;">
                <div>ID</div>
            </th>
            <th style="width:24%;">
                <div>Created By</div>
            </th>
            <th style="width:30%;">
                <div>Note</div>
            </th>
            <th style="width:22%;">
                <div>Date</div>
            </th>
           
            
            <th class="no-after"></th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="(note, index) in contactData.notes" :key="note.id">
            
            
            <td>{{ note.id || '' }}</td>
            <!-- Creator -->
            <td>{{ note.user.username || '' }}</td>
            <!-- Manager -->
            <td>{{ note.note || '' }}</td>
            <td>{{ note.created_at || '' }}</td>
            <td><button class="ms-3 ms-sm-3 btn btn-primary" @click="openDeleteModal(note)" v-if="superUser || canDeleteNote(note)"
              type="button" style="color:var(--secondary-color); font-weight:bold">
                <i class="wx-ic wx-ic-trash" title="Archive"></i>
               </button></td>

        </tr>
        <tr v-if="!contactData.notes || contactData.notes.length === 0">
            <td colspan="6" class="text-center">No notes available</td>
        </tr>
    </tbody>
</table>



    </div>

    <div class="modal fade" id="deleteModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Delete Note</h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  Are you sure you want to delete the note?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="confirmDelete">Delete</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="create-quicknote-form" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-bold" id="createQuickNotelLabel">New note</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="note" class="form-label" aria-label="Note" aria-placeholder="">Note</label>
            <textarea v-model="note" id="note" rows="4" cols="50" class="form-control"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click.prevent="submitQuickNoteForm">Create</button>
        </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import { ref, onMounted, onUnmounted, computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { get, createOrUpdate, getClientsServicesStatusesUsers } from '@/services/contacts-clients';
  import { create, deleteNote } from "@/services/quicknote";

  import { useToast } from 'vue-toastification';
  import { mapGetters } from 'vuex';
  import Select2 from 'vue3-select2-component';
import 'vue-toastification/dist/index.css';

  export default {
    name: "Supplier",
    components: {
        Select2
    },
 

    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Contacts');
        },
        canEditAllContacts() {
            return this.userPermissions?.editAll === 1;
        },
        canCreateContact() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
        canEditContact() {
         return localStorage.getItem('current_user_id') == this.contactData?.createdBy && this.userPermissions?.edit === 1;
      },
      
    },

    setup(){
      
const route = useRoute();
const note = ref("");

    },
    data() {
      return {
        editMode: false,
        showDeleteModal: false,
      noteToDelete: null,
        contactData: {
          id: null,
          name: '',
          email: '',
          occupation: '',
          description: '',
          email: '',
          phone: '',
          address: '',
          postal: '',
          afm: '',
          clientId: '',
          supplierId: '',
          createdBy: null
        },
        select2Settings: {
            placeholder: "Please select"
        },
        allData: {
            clients: [],
            suppliers: []
        }
      };
    },
    async mounted() {
        const allData = await getClientsServicesStatusesUsers();
        let newData = {clients: [], suppliers: []};    
        for (let i = 0; i < allData.data.clients.length; i++) {
            newData.clients.push({id: allData.data.clients[i].id, text: allData.data.clients[i].title});
        }
        for (let i = 0; i < allData.data.suppliers.length; i++) {
            newData.suppliers.push({id: allData.data.suppliers[i].id, text: allData.data.suppliers[i].title});
        }
        this.allData = newData;
        const contactData = await get({id: this.$route.query.id});
        if (contactData.data.success) {
            this.contactData = contactData.data.data;
        }
    },
    methods: {
      async save() {
        const r = await createOrUpdate(this.contactData);
        if (r.data.success) {
            this.editMode = false;
            useToast().success(r.data.message);
        } else {
            useToast().error(r.data.message);
        }
      },

      
      canDeleteNote(note) {
    console.log(note); // Log for debugging
    if (!note || !note.createdBy) {
      return false;
    }
    return localStorage.getItem('current_user_id') == note.createdBy;
  },

  openDeleteModal(note) {
    $('#deleteModal').modal('show');

          this.noteToDelete = note; // Store the note that will be deleted
    },

    openCreateNoteModal() {
    $('#create-quicknote-form').modal('show');
    },
     createSupplier () {
            $("#createModal").modal('show');
        },
    
    
    // Method to confirm deletion
    async confirmDelete() {
      if (this.noteToDelete) {
        try {
          const response = await deleteNote(this.noteToDelete.id); // Call the deleteNote function with the note ID

          if (response.data.success) {
            useToast().success('Note deleted successfully.');
            this.contactData.notes = this.contactData.notes.filter(note => note.id !== this.noteToDelete.id); // Remove note from the list
          } else {
            useToast().error(response.data.message || 'Failed to delete note.');
          }
        } catch (error) {
          useToast().error('Error occurred while deleting the note.');
        }
      }

      this.noteToDelete = null;
      $('#deleteModal').modal('hide');
    },

    

    async submitQuickNoteForm() {
/*         const contactId = route.query.id; 
 */       
        /* if (!contactId) {
            useToast().error("Contact ID is missing!");
            return;
        }
 */
        const response = await create(this.$route.query.id, { note: note.value });

        if (response.data.success) {
            useToast().success(response.data.message);
            note.value = ""; // Reset the note field
            $("#create-quicknote-form").modal("hide");
            const allData = await getClientsServicesStatusesUsers();
        let newData = {clients: [], suppliers: []};    
        for (let i = 0; i < allData.data.clients.length; i++) {
            newData.clients.push({id: allData.data.clients[i].id, text: allData.data.clients[i].title});
        }
        for (let i = 0; i < allData.data.suppliers.length; i++) {
            newData.suppliers.push({id: allData.data.suppliers[i].id, text: allData.data.suppliers[i].title});
        }
        this.allData = newData;
        const contactData = await get({id: this.$route.query.id});
        if (contactData.data.success) {
            this.contactData = contactData.data.data;
        }
        } else {
            useToast().error(response.data.message);
        }
  
},


      editContact() {
        this.editMode = true;
      },
      cancelEdit() {
        this.editMode = false;
      },
    },
  };
  </script>
  
  <style scoped>
  .supplier-view {
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  .header {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .logo {
    height: 40px;
  }
  .supplier-info {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;
  }
  .info-row {
    display: flex;
    gap: 15px;
  }
  .info-item {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  label{
    color:#606060;
    font-weight:bolder;
    size:20px;
  }
  input, textarea {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #EBEBEB;
  }
  .actions {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
  }
  .edit-btn, .cancel-btn {
    
    border: none;
    cursor: pointer;
    margin-right: 10px;
  }
  .edit-btn, .save-btn {
    background-color: #7F7F7F;
    color: white;
    font-weight:bolder;
    border:none;
    padding:10px;
    padding-left:20px;
    padding-right: 20px;
  }
  .cancel-btn {
    border:  #8C8C8C 2px solid;
    background: none;
    color:#8C8C8C;
    font-weight: bolder;
  }

  button{
    border-radius:5px;
  }

  .enabled{
    background-color: white;
  }

  
  </style>
  